module.exports = __webpack_public_path__ + "img/93.70f2c394.jpg";